// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/GestaoClientes_CarregaOrcamentosComCompromissoResponse.php
// Do not edit by hand — edit the PHP ResponseContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * ResponseContract for /gestao_clientes/carrega_orcamentos_com_compromisso
 *
 * Returns array of orcamento records with compromissos. Each row is the
 * Orcamentos_model::buscaDadosOrcamentos() projection (same SELECT that drives
 * the gestao_clientes dashboard), enriched with franquia/Localidade via
 * inserePropriedadeMany() and minus the Cancelado rows the controller skips.
 */
import type { GestaoClientes_BuscaDadosOrcamentoItemRow } from './GestaoClientes_BuscaDadosOrcamentoItemRow'
import type { ApiResponse } from '../services/httpService'
import { registerResponseContract } from './validate'

export type GestaoClientes_CarregaOrcamentosComCompromissoResponseDados = GestaoClientes_BuscaDadosOrcamentoItemRow[];

export type GestaoClientes_CarregaOrcamentosComCompromissoResponse = ApiResponse<GestaoClientes_CarregaOrcamentosComCompromissoResponseDados>;

registerResponseContract('GestaoClientes_CarregaOrcamentosComCompromissoResponse', {
  _root: {
    type: 'array',
    required: true,
    items: {
      ID:                      { type: 'number',  required: true },
      acoes:                   { type: 'string',  required: true },
      agendar:                 { type: 'string',  required: true },
      status:                  { type: 'string',  required: true },
      status_label:            { type: 'string',  required: true },
      orcamento_data:          { type: 'string',  required: true },
      orcamento_franquia_id:   { type: 'string',  required: true },
      nome_cliente:            { type: 'string',  required: true },
      pode_agendar:            { type: 'string',  required: true },
      agendar_motivos:         { type: 'array',   required: false },
      cliente_id:              { type: 'string',  required: true },
      cliente_ddi:             { type: 'string',  required: false },
      cliente_ddd:             { type: 'string',  required: false },
      cliente_telefone:        { type: 'string',  required: false },
      rua:                     { type: 'string',  required: false },
      bairro:                  { type: 'string',  required: false },
      orcamento_location_id:   { type: 'string',  required: false },
      orcamento_location_type: { type: 'string',  required: false },
      total:                   { type: 'string',  required: true },
      origem:                  { type: 'string',  required: false },
      franquia:                { type: 'string',  required: false },
      Localidade:              { type: 'string',  required: false },
    },
  },
})
